module.exports = __webpack_public_path__ + "static/media/ankush.4ac1390c.jpg";